/* import __COLOCATED_TEMPLATE__ from './price-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();